import React, { useContext, useState, useEffect } from "react";
import { Container, Row, Col, Button, Table, Form } from "react-bootstrap";
import "./Create.css";
import Select from "react-select";
import Header from "../../../Header/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import classNames from "classnames";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ModalSave from "../../../common/ModelSave";
import { useNavigate } from "react-router";
import { putData } from "../../../../utils/api";
import JoditEditor from "jodit-react";
import { variant_type } from "../../../../utils/common";

function Edit() {
  const { id } = useParams();

  const navigate = useNavigate();
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
    IMG_URL,
    postData,
    getDimension,
  } = useContext(Context);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    getValues,
    setValue,
    trigger,
  } = useForm({
    defaultValues: {
      variants: [{ name: "", price: "", mrp: "", image: "", description: "" }], // Default empty field
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "variants",
  });
  const variantType = watch("variant_type_id");
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const imageFiles = watch("images");

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();
      DataToSend.append("name", data?.name);
      DataToSend.append("note", data?.note);
      DataToSend.append("customization_status", true);
      DataToSend.append("description", data?.description);

      DataToSend.append("category_id", data?.category_id?.value);
      DataToSend.append("occasion_id", data?.occasion_id?.value);
      DataToSend.append("sub_category_id", data?.sub_category_id?.value);
      // DataToSend.append("vendor_id", data?.vendor_id?.value);

      // DataToSend.append(
      //   "p_child_category_id",
      //   data?.p_child_category_id?.value,
      // );

      DataToSend.append("image", data.image[0]);
      DataToSend.append("requirement", data?.requirement);

      // Append the images (multiple files)
      if (data?.images && data?.images.length > 0) {
        for (let i = 0; i < data.images.length; i++) {
          DataToSend.append("images", data.images[i]);
        }
      }
      DataToSend.append(
        "fabrics",
        JSON.stringify(data.fabrics.map((option) => option.value)),
      );

      DataToSend.append(
        "suitables",
        JSON.stringify(data.suitables.map((option) => option.value)),
      );

      let response;
      if (data?.name) {
        response = await putData(`/admin/designs/customize/${id}`, DataToSend);
      }

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.data });
        reset();
        setTimeout(() => {
          setShowModal(0);
          navigate("/user-customization");
        }, 1000);
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
        setTimeout(() => {
          setShowModal(0);
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [Countries, setCountries] = useState([]);

  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [childCategories, setChildCategories] = useState([]);

  const watchedUnit = watch("unit_id");

  const getAllCategories = async () => {
    const response = await getData("/common/masters/all-category");
    if (response?.success) {
      setCategories(await Select2Data(response?.data, "category_id"));
    }
  };
  const getAllSubCategories = async (id) => {
    const response = await getData(`/common/masters/all-sub-category/${id}`);
    if (response?.success) {
      setSubCategories(await Select2Data(response?.data, "sub_category_id"));
    }
  };
  const getAllChildCategories = async (id) => {
    const response = await getData(`/common/masters/all-child-category/${id}`);
    if (response?.success) {
      setChildCategories(
        await Select2Data(response?.data, "p_child_category_id"),
      );
    }
  };
  const getAllCountries = async () => {
    const response = await getData(`/common/masters/all-country`);
    if (response?.success) {
      setCountries(await Select2Data(response?.data, "made_in_id"));
    }
  };

  useEffect(() => {
    getAllCategories();
  }, []);
  const imageFile = watch("image");
  const GetEditData = async () => {
    const response = await getData(`/admin/designs/customize/${id}`);
    reset(response?.data);
    let previews = [];
    if (response?.data?.images?.length) {
      previews = response.data.images.map((img) => ({
        id: img.id,
        url: IMG_URL + img.image,
      }));
    }
    setImagePreviews(previews);
  };

  useEffect(() => {
    GetEditData();
  }, [id]);

  const [imagePreview, setImagePreview] = useState(null); // State to store image preview

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const [imagePreviews, setImagePreviews] = useState([]);
  const handleVarientImagesChange = (e) => {
    const files = Array.from(e.target.files || []);
    const urls = files.map((file) => ({
      id: null,
      url: URL.createObjectURL(file),
    }));

    setImagePreviews((prev) => [...(prev || []), ...urls]);
  };

  const handleRemoveImage = async (imageIndex) => {
    const targetImage = imagePreviews[imageIndex];

    // Optional confirm
    if (!window.confirm("Are you sure you want to delete this image?")) return;

    // If it's a server image (has an id), delete from server
    if (targetImage?.id) {
      try {
        await deleteData(`/admin/designs/image-delete/${targetImage.id}`);
      } catch (err) {
        console.error("Failed to delete image:", err);
        alert("Failed to delete image from server.");
        return;
      }
    }

    // Remove from preview state
    setImagePreviews((prev) => {
      const updatedImages = [...prev];
      updatedImages.splice(imageIndex, 1);
      return updatedImages;
    });
  };

  const [videoPreviews, setVideoPreview] = useState(null);

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setVideoPreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const [fabric, setFabric] = useState([]);
  const [occasion, setOccasion] = useState([]);
  const [suitables, setSuitables] = useState([]);
  const [vendors, setVendor] = useState([]);

  const getAllOccasion = async () => {
    const response = await getData(`/common/masters/all-occasion`);
    if (response?.success) {
      setOccasion(await Select2Data(response?.data, "occasion_id"));
    }
  };

  const getAllFabric = async () => {
    const response = await getData(`/common/masters/all-fabric`);
    if (response?.success) {
      setFabric(await Select2Data(response?.data, "fabric_id"));
    }
  };
  const getAllSuitable = async () => {
    const response = await getData(`/common/masters/all-suitable`);
    if (response?.success) {
      setSuitables(await Select2Data(response?.data, "suitable_id"));
    }
  };

  const getAllVendor = async () => {
    const response = await getData(`/common/masters/all-vendors`);
    if (response?.success) {
      setVendor(await Select2Data(response?.data, "vendor_id"));
    }
  };

  useEffect(() => {
    getAllSuitable();
    getAllFabric();
    getAllCategories();
    getAllOccasion();
    getAllVendor();
  }, []);

  return (
    <>
      <Header title={"Edit Design"} link={"/employee/employee_details"} />
      <section className="Create">
        {/* back button start */}
        {/* <div className="back_btn_holder">
          <div onClick={() => navigate(`/designs`)}>
            <FontAwesomeIcon className="back-btn" icon={faAngleLeft} />
            Back
          </div>
        </div> */}
        <div className="back_btn_holder">
          <div onClick={() => navigate(-1)}>
            <FontAwesomeIcon className="back-btn" icon={faAngleLeft} />
            Back
          </div>
        </div>
        {/* back button end */}

        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>1. Design Category</h6>
            </div>
            <div className="package-details-section">
              <div className="pending-table ">
                <div className="row ">
                  <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                    <Form.Label>Category</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`category_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Category",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.category_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={categories}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                            getAllSubCategories(selectedValue?.value);
                            setValue("sub_category_id", "");
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.category_id && (
                      <span className="text-danger">
                        {errors.category_id.message}
                      </span>
                    )}
                  </div>
                  <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                    <Form.Label>Sub Category</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`sub_category_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Sub Category",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.sub_category_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={subCategories}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                            getAllChildCategories(selectedValue?.value);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.sub_category_id && (
                      <span className="text-danger">
                        {errors.sub_category_id.message}
                      </span>
                    )}
                  </div>

                  {/* <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                    <Form.Label>Vendor</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`vendor_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Vendor",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.vendor_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={vendors}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                            getAllChildCategories(selectedValue?.value);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.vendor_id && (
                      <span className="text-danger">
                        {errors.vendor_id.message}
                      </span>
                    )}
                  </div> */}

                  {/* <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                    <Form.Label>Child Category</Form.Label>
                    <Controller
                      className="select-contoller"
                      name={`p_child_category_id`} // name of the field
                      control={control}
                      rules={{
                        required: "Select Child Category",
                      }}
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors?.p_child_category_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                          // {...field}
                          options={childCategories}
                          onChange={(selectedValue) => {
                            onChange(selectedValue);
                          }}
                          onBlur={onBlur}
                          value={value}
                          ref={ref}
                        />
                      )}
                    />
                    {errors.p_child_category_id && (
                      <span className="text-danger">
                        {errors.p_child_category_id.message}
                      </span>
                    )}
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>2. Design</h6>
            </div>
            <div className="package-details-section">
              {/* Package Weight */}
              <Row className="detail-row">
                <Col md={4}>
                  <div className="detail-label">Name</div>
                </Col>
                <Col lg={4} md={4}>
                  <div className="">
                    <Form.Control
                      type="text"
                      name={`name`}
                      placeholder="name"
                      className={classNames("", {
                        "is-invalid": errors?.name,
                      })}
                      {...register(`name`, {
                        required: "name is required",
                        validate: (value) => {
                          const words = value.match(/\b\w+\b/g);
                          return (
                            !words ||
                            words.length <= 50 ||
                            "Data must be 100 words or less"
                          );
                        },
                      })}
                    />
                  </div>
                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </Col>
              </Row>

              <Row className="detail-row">
                <Col md={4}>
                  <div className="detail-label">Thumbnail Upload image</div>
                </Col>
                <Col lg={4}>
                  <div className="d-flex align-items-center">
                    <Form.Control
                      type="file"
                      name="image"
                      accept="image/*"
                      className={classNames("", {
                        "is-invalid": errors?.image,
                      })}
                      {...register("image", {
                        // validate: async (value) => {
                        //   if (
                        //     typeof value !== "string" &&
                        //     value &&
                        //     value[0]
                        //   ) {
                        //     const file = value[0];
                        //     const fileTypes = [
                        //       "jpg",
                        //       "jpeg",
                        //       "png",
                        //       "webp",
                        //     ];
                        //     const fileType = file.name
                        //       .split(".")
                        //       .pop()
                        //       .toLowerCase();
                        //     if (!fileTypes.includes(fileType)) {
                        //       return `Please upload a valid file format. (${fileTypes.join(
                        //         ", ",
                        //       )})`;
                        //     }
                        //     const sizes = await getDimension(file);
                        //     if (
                        //       sizes.width !== 928 ||
                        //       sizes.height !== 945
                        //     ) {
                        //       return "Image width and height must be 928 px and 945 px";
                        //     }
                        //     const fileSize = Math.round(file.size / 1024); // in KB
                        //     if (fileSize > 500) {
                        //       return "File size must be less than 500KB";
                        //     }
                        //   }
                        // },
                      })}
                      // onChange={handleImageChange}
                    />
                  </div>

                  {errors.image && (
                    <span className="text-danger">{errors.image.message}</span>
                  )}
                </Col>
                <Col lg={4}>
                  {typeof getValues("image") === "string" ? (
                    // If image is a string (URL), show the preview
                    <div className="image-preview-container ms-5">
                      <img
                        src={IMG_URL + getValues("image")}
                        alt="Preview"
                        className="image-preview"
                        width={50}
                      />
                    </div>
                  ) : (
                    imageFile &&
                    imageFile?.length > 0 && (
                      <div className="image-preview-container">
                        <img
                          // src={URL.createObjectURL(getValues("image")[0])}
                          src={URL?.createObjectURL(imageFile[0])}
                          alt="Preview"
                          className="image-preview"
                        />
                      </div>
                    )
                  )}
                </Col>
              </Row>
            </div>
          </div>
          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>3.Add Multiple Images</h6>
            </div>
            <div className="package-details-section">
              {/* Pickup Slot */}
              <Row className="detail-row">
                <Col lg={4} md={4}>
                  <div className="d-flex align-items-center">
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.images,
                      })}
                      type="file"
                      multiple
                      {...register(`images`, {
                        // required: "Images are required",
                      })}
                      accept="image/*"
                      id={`variantImages`}
                      onChange={(e) => handleVarientImagesChange(e)}
                    />
                  </div>
                  {errors.images && (
                    <span className="text-danger">{errors.images.message}</span>
                  )}
                </Col>

                <div className="mt-2 d-flex flex-wrap">
                  {Array.isArray(imagePreviews) && (
                    <div className="d-flex flex-wrap gap-2 mt-2">
                      {imagePreviews.map((src, i) => (
                        <div
                          key={i}
                          className="varimggdiv position-relative"
                          onClick={() => handleRemoveImage(i)}
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            key={i}
                            src={src?.url}
                            alt={`Preview ${i}`}
                            style={{
                              width: "80px",
                              height: "80px",
                              objectFit: "cover",
                              border: "1px solid #ddd",
                              borderRadius: "4px",
                            }}
                          />
                          <FontAwesomeIcon
                            className="dlticon position-absolute top-0 end-0 m-1 text-danger"
                            icon="xmark"
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </Row>
            </div>
          </div>

          <div className="oder-detail-holder mb-3">
            <div className="heading-holder">
              <h6>4. Details</h6>
            </div>

            <div className="package-details-section">
              <Row className="detail-row">
                <div className="col-xxl-4 col-xl-3  col-lg-6  col-md-2 col-12 mb-2">
                  <Form.Label>Occasion</Form.Label>
                  <Controller
                    className="select-contoller"
                    name={`occasion_id`} // name of the field
                    control={control}
                    rules={{
                      required: "Select Occasion",
                    }}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors?.occasion_id
                              ? "red"
                              : baseStyles.borderColor,
                          }),
                        }}
                        // {...field}
                        options={occasion}
                        onChange={(selectedValue) => {
                          onChange(selectedValue);
                        }}
                        onBlur={onBlur}
                        value={value}
                        ref={ref}
                      />
                    )}
                  />
                  {errors.occasion_id && (
                    <span className="text-danger">
                      {errors.occasion_id.message}
                    </span>
                  )}
                </div>

                <div className="col-xxl-4 col-xl-3  col-lg-6  col-md-2 col-12 mb-2">
                  <Form.Label>Suitables</Form.Label>
                  <Controller
                    className="select-contoller"
                    name={`suitables`} // name of the field
                    control={control}
                    rules={{
                      required: "Select Suitables",
                    }}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <Select
                        isMulti
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors?.suitables
                              ? "red"
                              : baseStyles.borderColor,
                          }),
                        }}
                        // {...field}
                        options={suitables}
                        onChange={(selectedValue) => {
                          onChange(selectedValue);
                        }}
                        onBlur={onBlur}
                        value={value}
                        ref={ref}
                      />
                    )}
                  />
                  {errors.suitables && (
                    <span className="text-danger">
                      {errors.suitables.message}
                    </span>
                  )}
                </div>

                <div className="col-xxl-4 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                  <Form.Label>Fabrics</Form.Label>
                  <Controller
                    className="select-contoller"
                    name={`fabrics`} // name of the field
                    control={control}
                    rules={{
                      required: "Select Fabric",
                    }}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <Select
                        isMulti
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors?.fabrics
                              ? "red"
                              : baseStyles.borderColor,
                          }),
                        }}
                        // {...field}
                        options={fabric}
                        onChange={(selectedValue) => {
                          onChange(selectedValue);
                        }}
                        onBlur={onBlur}
                        value={value}
                        ref={ref}
                      />
                    )}
                  />
                  {errors.fabrics && (
                    <span className="text-danger">
                      {errors.fabrics.message}
                    </span>
                  )}
                </div>
              </Row>

              <Row className="detail-row">
                <Col md={4}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>Note</Form.Label>
                      <Form.Group>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          name={`note`}
                          placeholder="Note"
                          className={classNames("", {
                            "is-invalid": errors?.note, // Adjusted error checking
                          })}
                          {...register(`note`, {
                            required: "Note is required",
                          })}
                        />
                        {errors.note && (
                          <span className="text-danger">
                            {errors.note.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>Description</Form.Label>
                      <Form.Group>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          name={`description`}
                          placeholder="Description"
                          className={classNames("", {
                            "is-invalid": errors?.description, // Adjusted error checking
                          })}
                          {...register(`description`, {
                            required: "Description No is required",
                          })}
                        />
                        {errors.description && (
                          <span className="text-danger">
                            {errors.description.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="main-form-section mt-3">
                    <Row className="justify-content-center">
                      <Form.Label>Requirement</Form.Label>
                      <Form.Group>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          name={`requirement`}
                          placeholder="requirement"
                          className={classNames("", {
                            "is-invalid": errors?.requirement, // Adjusted error checking
                          })}
                          {...register(`requirement`, {
                            required: "Requirement is required",
                          })}
                        />
                        {errors.requirement && (
                          <span className="text-danger">
                            {errors.requirement.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                </Col>
              </Row>
              <div className="d-flex justify-content-center">
                <div className="text-center mt-4 mx-2">
                  <button
                    className="Back-button"
                    type="submit"
                    onClick={() => navigate("/designs")}
                  >
                    Cancel
                  </button>
                </div>

                <div className="text-center mt-4 mx-2">
                  <button
                    className="schedule-button"
                    type="submit"
                    // onClick={onSubmit}
                  >
                    Update Design
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Form>

        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </section>
    </>
  );
}

export default Edit;
